<template>
  <b-modal
    id="multi-imei-modal"
    v-model="showModal"
    :title="mode === 'add' ? $t('master.multiImei.add.title') : $t('master.multiImei.edit.title')"
    @hidden="onHidden"
    centered
    size="lg"
  >
    <MultiImeiForm
      :key="showModal"
      :data="formData"
      :mode="mode"
      :serverRegion="serverRegion"
      @update-selection="onSelection"
      @validated="onValidation"
    />

    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer">
        <b-col sm="12" md="4" class="mc-modal__filter-footer-fav"> </b-col>
        <b-col sm="12" md="8" class="mc-modal__filter-footer-btn">
          <b-button variant="outline-primary" @click="onCancel" class="me-3" :disabled="isLoading">
            {{ $t('global.cancel') }}
          </b-button>
          <b-button variant="primary" @click="onSave" :disabled="isLoading || !isValid">
            <b-spinner small v-if="isLoading" class="mr-2" />
            {{ isLoading ? $t('global.saving') : $t('global.save') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import MultiImeiForm from './Form.vue'
import * as vehicleApi from '@/services/rest-api-sms/lib/vehicle/vehicle'

export default {
  name: 'MultiImeiModal',

  components: { MultiImeiForm },

  props: {
    value: { type: Boolean, default: false },
    mode: { type: String, default: 'add' }, // 'add' | 'edit'
    data: { type: Object, default: null },
    serverRegion: { type: String, default: 'SG' },
  },

  data() {
    return {
      formData: null,
      selection: null,
      isLoading: false,
      isValid: false,
      showModal: false,
    }
  },

  watch: {
    data(val) {
      this.formData = val
    },

    value(val) {
      this.showModal = val
      if (val) {
        this.isValid = false
        this.selection = null
      }
    },
  },

  methods: {
    onValidation(status) {
      this.isValid = status
    },

    onSelection(payload) {
      this.selection = payload
    },

    async onSave() {
      if (!this.selection?.child || !this.selection?.parent) {
        this.$mcToast.error(this.$t('global.required'))
        return
      }

      this.isLoading = true
      try {
        let response

        if (this.mode === 'add') {
          const payload = {
            child_vehicle_id: this.selection.child.vehicle_id,
            parent_vehicle_id: this.selection.parent.vehicle_id,
          }
          response = await vehicleApi.addMultiImei(payload, this.serverRegion)
        } else if (this.mode === 'edit-parent') {
          const payload = {
            parent_vehicle_id: this.selection.parent.vehicle_id,
          }
          response = await vehicleApi.updateMultiImeiParent(
            this.selection.child.vehicle_id,
            payload,
            this.serverRegion
          )
        } else if (this.mode === 'edit-child') {
          const payload = {
            child_vehicle_id: this.selection.child.vehicle_id,
          }
          response = await vehicleApi.updateMultiImeiChild(
            this.selection.parent.vehicle_id,
            payload,
            this.serverRegion
          )
        }

        if (response?.status === 200) {
          if (this.mode === 'add') {
            this.$mcToast.success(
              this.$t('master.multiImei.add.success', {
                licensePlate: this.selection.parent?.license_plate,
              })
            )
          } else if (this.mode === 'edit-parent') {
            this.$mcToast.success(
              this.$t('master.multiImei.edit.parent.success', {
                licensePlate: this.selection.child?.license_plate,
              })
            )
          } else if (this.mode === 'edit-child') {
            this.$mcToast.success(
              this.$t('master.multiImei.edit.child.success', {
                licensePlate: this.selection.parent?.license_plate,
              })
            )
          }
        }
        this.$emit('saved') // biar parent reload data list
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoading = false
      }
    },

    onHidden() {
      this.showModal = false
      this.isLoading = false
      this.$emit('input', false) // tutup modal dari tombol cancel
    },

    onCancel() {
      this.showModal = false
      this.isLoading = false
      this.$emit('input', false) // tutup modal dari tombol cancel
    },
  },
}
</script>
